<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="600" scrollable>
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Thêm điểm danh đến
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="py-6">
        <div class="mb-3">
          * Sau khi thêm điểm danh thành công, thông báo sẽ được gửi đến Phụ huynh (gửi theo Tự động theo đăng ký trong
          Sổ liên lạc)
        </div>
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <DateIOSPicker
                label="Ngày"
                :date.sync="datetime"
                outlined
                class="required"
                :rules="[$rules.required, $rules.date, $rules.dateFromNow]"
                dense
              />
            </v-col>
            <v-col cols="12">
              <GradeClassStudentSelect
                ref="gcsSelectForm"
                :gradeCol="{ cols: 12, md: 6 }"
                :classCol="{ cols: 12, md: 6 }"
                :studentCol="{ cols: 12 }"
                :studentRules="[$rules.required]"
                @changed="gradeClassStudentChange"
              />
            </v-col>
            <v-col cols="12" class="d-flex flex-row align-center">
              <div class="mr-2">Giờ đến (24h) <span class="error--text">*</span></div>
              <TimeInput
                label="Giờ đến lớp (24h)"
                outlined
                dense
                outline
                :date.sync="time"
                :selectedDate="getCurrentDate"
                class="required"
                :rules="[$rules.required, $rules.time]"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn class="ma-2" outlined light depressed @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
// import { Attendance } from '@/plugins/api'
import moment from 'moment'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import TimeInput from '@/components/basic/TimeInput.vue'

export default {
  components: {
    DateIOSPicker,
    GradeClassStudentSelect,
    TimeInput
  },
  data() {
    return {
      dialog: false,
      datetime: moment().toISOString(),
      selectedGrade: {},
      selectedClass: {},
      selectedStudent: {},
      time: ''
    }
  },
  props: {
    state: Boolean
  },
  computed: {
    ...mapState('attendance', ['date']),
    getCurrentDate() {
      return moment(this.date).format('DD/MM/YYYY')
    }
  },
  methods: {
    ...mapActions('attendance', ['getAllAttendances', 'checkinAttendance']),
    openDialog() {
      this.dialog = true
    },
    cancel() {
      this.dialog = false
      this.reset()
    },
    gradeClassStudentChange(data) {
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
      this.selectedStudent = { ...data.student }
    },
    async save() {
      if (!this.$refs.form.validate() || !this.$refs.gcsSelectForm.validate()) {
        return
      }
      try {
        this.$loading.active = true
        const datetime = moment(this.time)
          .date(moment(this.datetime).date())
          .month(moment(this.datetime).month())
          .year(moment(this.datetime).year())
          .toISOString()

        const dateGte = moment(datetime)
          .startOf('day')
          .toISOString()
        const dateLte = moment(datetime)
          .endOf('day')
          .toISOString()

        const attendances = await this.getAllAttendances({
          searchParams: {
            student: this.selectedStudent.id,
            time_gte: dateGte,
            time_lte: dateLte
          },
          disableSave: true
        })
        const attendance = attendances[0]
        if (attendance) {
          if (attendance.status === 'attendance') {
            this.$alert.error('Học sinh này đã đến trường')
            return
          }
          if (attendance.status === 'left' && moment(datetime).isSameOrBefore(moment(attendance.time))) {
            this.$alert.error(
              'Thời gian đến không hợp lệ. Học sinh đã rời trường lúc ' + moment(attendance.time).format('HH:mm')
            )
            return
          }
        }
        await this.checkinAttendance({
          student: this.selectedStudent,
          time: datetime,
          status: 'attendance'
        })
        this.$alert.addSuccess()
        this.reset()
        this.$emit('refresh')
        this.dialog = false
      } catch (error) {
        console.error(error)
        this.$alert.addError()
      } finally {
        this.$loading.active = false
      }
    },
    reset() {
      this.selectedGrade = null
      this.selectedClass = null
      this.selectedStudent = null
      this.time = null
      this.$refs.form.resetValidation()
      this.$refs.gcsSelectForm.reset()
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    },
    dialog(newVal) {
      if (!newVal) {
        this.reset()
      }
    }
  }
}
</script>
